var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13944 0 0 3.13944 0 7C0 10.8606 3.13944 14 7 14C10.8606 14 14 10.8606 14 7C14 3.13944 10.8606 0 7 0ZM7 0.933389C10.3561 0.933389 13.0667 3.644 13.0667 7.00006C13.0667 10.3561 10.3561 13.0667 7 13.0667C3.64394 13.0667 0.933334 10.3561 0.933334 7.00006C0.933334 3.644 3.64394 0.933389 7 0.933389ZM6.99512 2.47917C6.97884 2.47993 6.96267 2.48155 6.94651 2.48405C6.83138 2.49729 6.72537 2.55295 6.64898 2.64008C6.57259 2.72721 6.53136 2.83974 6.53331 2.9555V8.24439C6.53157 8.36928 6.57997 8.48972 6.66764 8.57858C6.75531 8.66756 6.87511 8.71769 7 8.71769C7.1249 8.71769 7.24468 8.66756 7.33236 8.57858C7.42003 8.48972 7.46843 8.36927 7.46669 8.24439V2.9555C7.4693 2.8293 7.42058 2.70734 7.33171 2.6175C7.24295 2.52776 7.12142 2.47785 6.99513 2.47915L6.99512 2.47917ZM7 9.48889C6.48447 9.48889 6.06661 9.90675 6.06661 10.4222C6.06661 10.9377 6.48447 11.3556 7 11.3556C7.51553 11.3556 7.93339 10.9377 7.93339 10.4222C7.93339 9.90675 7.51553 9.48889 7 9.48889Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d39fe93f.svg";
export { ForwardRef as ReactComponent };